import _objectSpread from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import React from 'react';
import Text from './Text';
import Checkbox from './Checkbox';
import Radio from './Radio';
import CheckboxGroup from './CheckboxGroup';
import RadioGroup from './RadioGroup'; // import Select from './Select'

import Date from './Date';
import Time from './Time';
import DateTime from './DateTime';
import DateRange from './DateRange';
import Switch from './Switch';
import SwitchGroup from './SwitchGroup';
import Find from './Find';
import Autocomplete from './Autocomplete';
import File from './File';
import { FieldType } from '../Form.models';
import isNull from 'lodash/isNull';
import { withStyles } from '@material-ui/core';
import styles from './Fields.style';
import Api from '../../../api';
import { Subject, of } from 'rxjs';
import { catchError, map, takeUntil } from 'rxjs/operators';
import get from 'lodash/get';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';
import isEmpty from 'lodash/isEmpty';
import { findDOMNode } from 'react-dom';
export { Text, Checkbox, Radio, CheckboxGroup, RadioGroup // Select,
, Date, Time, DateTime, DateRange, Switch, SwitchGroup, Find, Autocomplete, File };
/**
 * Форматировние query параметров
 * @param params
 */

var queryParamsDefaultAdapter = function queryParamsDefaultAdapter(params) {
  var data = {};

  if (params) {
    if (params.limit || params.offset) {
      data.limit = params.limit;
      data.offset = params.offset || 0;
    }

    if (params.orderBy) {
      data.orderBy = params.orderBy;
    }

    if (params.filter) {
      var filter = pickBy(params.filter, identity);

      if (!isEmpty(filter)) {
        data.filter = pickBy(params.filter, identity);
      }
    }
  }

  return data;
};

var responseDataDefaultAdapter = function responseDataDefaultAdapter(data) {
  return {
    items: get(data, 'response.items', []),
    total: get(data, 'response.total', 0)
  };
};

var valueDefaultAdapter = function valueDefaultAdapter(data) {
  return data;
};
/**
 * Состояние инициализации
 */


var initialState = {
  items: [],
  total: 0,
  loading: false,
  filterParams: {},
  labelWidth: 0
};

var Field =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Field, _React$Component);

  function Field(props) {
    var _this;

    _classCallCheck(this, Field);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Field).call(this, props));
    _this.field = null;
    _this.unsubscribe = new Subject();
    _this.inputLabelRef = React.createRef();
    _this.labelEl = null;
    /**
     * Запрос данных
     */

    _this.fetch = function () {
      var requestParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var filterParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;
      var field = _this.props.field;

      if ('params' in field && 'url' in field.params) {
        var params = field.params; // отменяем текущий запрос

        _this.unsubscribe.next();

        var newState = {
          filterParams: _objectSpread({}, _this.state.filterParams, {}, filterParams),
          loading: true
        };

        _this.setState(newState, function () {
          var queryParamsAdapter = 'queryParamsAdapter' in params ? params.queryParamsAdapter : queryParamsDefaultAdapter;
          var responseDataAdapter = 'responseDataAdapter' in params ? params.responseDataAdapter : responseDataDefaultAdapter;
          Api.get(params.url, queryParamsAdapter(_objectSpread({}, requestParams, {
            filter: _this.state.filterParams
          }))).pipe(takeUntil(_this.unsubscribe), map(responseDataAdapter), catchError(function (err) {
            return of(err.message);
          })).subscribe(function (_ref) {
            var items = _ref.items,
                total = _ref.total;

            _this.setState({
              items: items,
              total: total,
              loading: false
            }, function () {
              cb && cb(_this.state);
            });
          });
        });
      }
    };
    /**
     * Сброс стейта и отмена запроса данных
     */


    _this.reset = function () {
      _this.unsubscribe.next();

      _this.setState(initialState);
    };

    _this.getValueFrom = function (data) {
      var field = _this.props.field;

      if ('params' in field && 'url' in field.params) {
        var params = field.params;
        var valueAdapter = 'valueAdapter' in params ? params.valueAdapter : valueDefaultAdapter;
        return valueAdapter(data);
      }

      return data;
    };

    _this.field = _this.getField(props.field.type);
    _this.state = initialState;
    return _this;
  }

  _createClass(Field, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setLabelElAndWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.labelEl) {
        this.setLabelElAndWidth();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unsubscribe.next();
      this.unsubscribe.complete();
    }
  }, {
    key: "setLabelElAndWidth",
    value: function setLabelElAndWidth() {
      this.labelEl = findDOMNode(this.inputLabelRef.current); // console.log(this.props.field.name, this.labelEl)

      if (this.labelEl) {
        // console.log(this.props.field.name, (this.labelEl as HTMLElement).offsetWidth)
        this.setState({
          labelWidth: this.labelEl.offsetWidth
        });
      }
    }
    /**
     * Получение компонента поля
     * @param type Тип поля
     */

  }, {
    key: "getField",
    value: function getField(type) {
      switch (type) {
        case FieldType.Hidden:
        case FieldType.Text:
        case FieldType.Email:
        case FieldType.Password:
        case FieldType.Number:
        case FieldType.Search:
        case FieldType.Textarea:
          return Text;

        case FieldType.Checkbox:
          return Checkbox;

        case FieldType.CheckboxGroup:
          return CheckboxGroup;

        case FieldType.Radio:
          return Radio;

        case FieldType.RadioGroup:
          return RadioGroup;

        case FieldType.Date:
          return Date;

        case FieldType.Time:
          return Time;

        case FieldType.DateTime:
          return DateTime;

        case FieldType.DateRange:
          return DateRange;

        case FieldType.Switch:
          return Switch;

        case FieldType.SwitchGroup:
          return SwitchGroup;

        case FieldType.Find:
          return Find;

        case FieldType.Select:
        case FieldType.MultiSelect:
        case FieldType.Autocomplete:
        case FieldType.MultiAutocomplete:
        case FieldType.AsyncAutocomplete:
        case FieldType.AsyncMultiAutocomplete:
          return Autocomplete;

        case FieldType.File:
          return File;

        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (isNull(this.field)) return null;
      var Component = this.field;
      var ajax = {
        fetch: this.fetch,
        reset: this.reset,
        getValue: this.getValueFrom,
        items: this.state.items,
        total: this.state.total,
        loading: this.state.loading
      };
      return React.createElement(Component, Object.assign({}, this.props, {
        ajax: ajax,
        labelWidth: this.state.labelWidth,
        inputLabelRef: this.inputLabelRef
      }));
    }
  }]);

  return Field;
}(React.Component);

export default withStyles(styles, {
  name: 'Field'
})(Field);